module.exports = __webpack_public_path__ + "static/img/step4_2sc@2x.ec2bfca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/howtobuy/step4_2sc@2x.jpg
// module id = 543
// module chunks = 0